type AttributeOption = {
  id: string;
  label: string;
  prompt: string;
  negativePrompt?: string;
  subcategoryId: string;
};

export const GENDER_OPTIONS: AttributeOption[] = [
  { id: 'female', label: 'Female', prompt: 'Female', subcategoryId: 'gender' },
  { id: 'male', label: 'Male', prompt: 'Male', subcategoryId: 'gender' },
  { id: 'other', label: 'Other', prompt: 'Other', subcategoryId: 'gender' },
];

export const AGE_OPTIONS: AttributeOption[] = [
  {
    id: '18',
    label: '18 yo',
    prompt: '18 years old',
    subcategoryId: 'age',
  },
  {
    id: '20s',
    label: '20s',
    prompt: '22 years old',
    subcategoryId: 'age',
  },
  {
    id: '30s',
    label: '30s',
    prompt: '32 years old',
    subcategoryId: 'age',
  },
  {
    id: '40s',
    label: '40s',
    prompt: '42 years old',
    subcategoryId: 'age',
  },
  {
    id: '50s',
    label: '50s',
    prompt: '52 years old',
    subcategoryId: 'age',
  },
  {
    id: '60s',
    label: '60s',
    prompt: '62 years old',
    subcategoryId: 'age',
  },
  {
    id: '70s',
    label: '70s',
    prompt: '72 years old',
    subcategoryId: 'age',
  },
];

export const ORIGIN_OPTIONS = [
  {
    id: 'sweden',
    label: '🇸🇪 Sweden',
    prompt: 'Sweden',
    subcategoryId: 'origin',
  },
  {
    id: 'united_states',
    label: '🇺🇸 United States',
    prompt: 'United States',
    subcategoryId: 'origin',
  },
  {
    id: 'india',
    label: '🇮🇳 India',
    prompt: 'India',
    subcategoryId: 'origin',
  },
  {
    id: 'germany',
    label: '🇩🇪 Germany',
    prompt: 'Germany',
    subcategoryId: 'origin',
  },
  {
    id: 'nigeria',
    label: '🇳🇬 Nigeria',
    prompt: 'Nigeria',
    subcategoryId: 'origin',
  },
  {
    id: 'saudi arabia',
    label: '🇸🇦 Saudi Arabia',
    prompt: 'Saudi Arabia',
    subcategoryId: 'origin',
  },
  {
    id: 'united_kingdom',
    label: '🇬🇧 United Kingdom',
    prompt: 'United Kingdom',
    subcategoryId: 'origin',
  },
  {
    id: 'france',
    label: '🇫🇷 France',
    prompt: 'France',
    subcategoryId: 'origin',
  },
  {
    id: 'brazil',
    label: '🇧🇷 Brazil',
    prompt: 'Brazil',
    subcategoryId: 'origin',
  },
  {
    id: 'russia',
    label: '🇷🇺 Russia',
    prompt: 'Russia',
    subcategoryId: 'origin',
  },
  {
    id: 'spain',
    label: '🇪🇸 Spain',
    prompt: 'Spain',
    subcategoryId: 'origin',
  },
  {
    id: 'italy',
    label: '🇮🇹 Italy',
    prompt: 'Italy',
    subcategoryId: 'origin',
  },
  {
    id: 'netherlands',
    label: '🇳🇱 Netherlands',
    prompt: 'Netherlands',
    subcategoryId: 'origin',
  },
  {
    id: 'mexico',
    label: '🇲🇽 Mexico',
    prompt: 'Mexico',
    subcategoryId: 'origin',
  },
  {
    id: 'malaysia',
    label: '🇲🇾 Malaysia',
    prompt: 'Malaysia',
    subcategoryId: 'origin',
  },
  {
    id: 'japan',
    label: '🇯🇵 Japan',
    prompt: 'Japan',
    subcategoryId: 'origin',
  },
];

export const FACE_TYPE_OPTIONS: AttributeOption[] = [
  {
    id: 'supermodel',
    label: 'Supermodel',
    prompt: 'supermodel face',
    subcategoryId: 'face',
  },
  {
    id: 'no-makeup',
    label: 'No makeup',
    prompt: 'no makeup face, natural',
    subcategoryId: 'face',
  },
  {
    id: 'cute',
    label: 'Cute',
    prompt: 'cute face',
    subcategoryId: 'face',
  },
  {
    id: 'sexy',
    label: 'Sexy',
    prompt: 'sexy face',
    subcategoryId: 'face',
  },
  {
    id: 'next-door',
    label: 'Girl next door',
    prompt: 'Pretty girl next door',
    subcategoryId: 'face',
  },
  {
    id: 'classical beauty',
    label: 'Classical beauty',
    prompt: 'Classically beautiful face',
    subcategoryId: 'face',
  },
  {
    id: 'goth',
    label: 'Goth',
    prompt: '(Goth) face',
    subcategoryId: 'face',
  },
  {
    id: 'emo',
    label: 'Emo',
    prompt: '(Emo) face',
    subcategoryId: 'face',
  },
  {
    id: 'punk',
    label: 'Punk',
    prompt: 'Punk-rock face',
    subcategoryId: 'face',
  },
  {
    id: 'hipster',
    label: 'Hipster',
    prompt: 'Hipster face',
    subcategoryId: 'face',
  },
  {
    id: 'nerdy',
    label: 'Nerdy',
    prompt: '(Nerdy) face, glasses',
    subcategoryId: 'face',
  },
];

export const HAIR_COLOR_OPTIONS: AttributeOption[] = [
  {
    id: 'blonde',
    label: '🟡 Blonde',
    prompt: 'Blonde hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'brunette',
    label: '🟤 Brunette',
    prompt: 'Brunette hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'redhead',
    label: '🔴 Redhead',
    prompt: 'Redhead hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'black',
    label: '⚫ Black',
    prompt: 'Black hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'rainbow',
    label: '🌈 Rainbow',
    prompt: 'Rainbow-colored hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'electric-blue',
    label: '🔵 Electric Blue',
    prompt: 'Electric blue hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'ginger',
    label: 'Ginger',
    prompt: 'Ginger hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'neon',
    label: 'Neon',
    prompt: 'Neon-colored hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'balayage',
    label: 'Balayage',
    prompt: 'Balayage hair',
    subcategoryId: 'hair-color',
  },
  {
    id: 'silver',
    label: 'Silver',
    prompt: 'Silver hair',
    subcategoryId: 'hair-color',
  },
];

export const HAIR_STYLE_OPTIONS = [
  {
    id: 'long',
    label: 'Long',
    prompt: 'Long hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'medium hair',
    label: 'Medium',
    prompt: 'Medium hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'short',
    label: 'Short',
    prompt: 'Short hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'ponytail',
    label: 'Ponytail hair',
    prompt: 'Ponytail',
    subcategoryId: 'hair-style',
  },
  {
    id: 'hijab',
    label: 'Hijab',
    prompt: '(Hijab) headwear',
    subcategoryId: 'hair-style',
  },
  {
    id: 'curly',
    label: 'Curly',
    prompt: 'Curly hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'straight',
    label: 'Straight',
    prompt: 'Straight hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'wavy',
    label: 'Wavy',
    prompt: 'Wavy hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'messy',
    label: 'Messy',
    prompt: 'Messy hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'messy-bun',
    label: 'Messy Bun',
    prompt: 'Messy bun hair',
    subcategoryId: 'hair-style',
  },
  {
    id: 'braided',
    label: 'Braided',
    prompt: 'Braided hair',
    subcategoryId: 'hair-style',
  },
];

export const EYE_COLOR_OPTIONS: AttributeOption[] = [
  {
    id: 'brown',
    label: 'Brown',
    prompt: 'Brown eyes',
    subcategoryId: 'eye-color',
  },
  {
    id: 'blue',
    label: 'Blue',
    prompt: 'Blue eyes',
    subcategoryId: 'eye-color',
  },
  {
    id: 'green',
    label: 'Green',
    prompt: 'Green eyes',
    subcategoryId: 'eye-color',
  },
  {
    id: 'hazel',
    label: 'Hazel',
    prompt: 'Hazel eyes',
    subcategoryId: 'eye-color',
  },
  {
    id: 'gray',
    label: 'Gray',
    prompt: 'Gray eyes',
    subcategoryId: 'eye-color',
  },
];

export const BODY_TYPE_OPTIONS: AttributeOption[] = [
  {
    id: 'petite',
    label: 'Petite',
    prompt: 'Petite body',
    subcategoryId: 'body-type',
  },
  {
    id: 'curvy',
    label: 'Curvy',
    prompt: 'Curvy body',
    subcategoryId: 'body-type',
  },
  {
    id: 'athletic',
    label: 'Athletic',
    prompt: 'Athletic body',
    subcategoryId: 'body-type',
  },
  {
    id: 'chubby',
    label: 'Chubby',
    prompt: '(Chubby) body',
    subcategoryId: 'body-type',
  },
];

export const BOOB_OPTIONS: AttributeOption[] = [
  {
    id: 'small boobs',
    label: 'Small',
    prompt: 'Small boobs',
    negativePrompt: '(Big breasts)',
    subcategoryId: 'boobs',
  },
  {
    id: 'medium boobs',
    label: 'Medium',
    prompt: 'Medium boobs',
    negativePrompt: 'fake breasts, big breasts',
    subcategoryId: 'boobs',
  },
  {
    id: 'big boobs',
    label: 'Big',
    prompt: 'Big boobs',
    subcategoryId: 'boobs',
  },
  {
    id: 'saggy boobs',
    label: 'Saggy',
    prompt: '(Saggy), natural boobs',
    subcategoryId: 'boobs',
  },
  {
    id: 'fake boobs',
    label: 'Fake',
    prompt: 'Silicon boobs',
    subcategoryId: 'boobs',
  },
];

export const CLOTHING_OPTIONS: AttributeOption[] = [
  {
    id: 'nude',
    label: 'Nude',
    prompt: '(nude:1.1)',
    negativePrompt: 'clothes, underwear',
    subcategoryId: 'clothing',
  },
  {
    id: 'bathrobe',
    label: 'Bathrobe',
    prompt: 'Bathrobe',
    subcategoryId: 'clothing',
  },
  {
    id: 'bdsm',
    label: 'BDSM',
    prompt: 'BDSM outfit',
    subcategoryId: 'clothing',
  },
  {
    id: 'bikini',
    label: 'Bikini',
    prompt: 'Bikini',
    subcategoryId: 'clothing',
  },
  {
    id: 'cheerleader',
    label: 'Cheerleader',
    prompt: 'Cheerleader outfit',
    subcategoryId: 'clothing',
  },
  {
    id: 'topless',
    label: 'Topless',
    prompt: '(Topless:1.1)',
    negativePrompt: '(top, shirt)',
    subcategoryId: 'clothing',
  },
  {
    id: 'choker',
    label: 'Choker',
    prompt: 'Choker',
    subcategoryId: 'clothing',
  },
  {
    id: 'summerdress',
    label: 'Summer Dress',
    prompt: 'Summer dress, colorful flowers',
    subcategoryId: 'clothing',
  },
  {
    id: 'fishnet',
    label: 'Fishnet',
    prompt: 'Fishnet attire',
    subcategoryId: 'clothing',
  },
  {
    id: 'flight_attendant',
    label: 'Flight Attendant',
    prompt: '(Flight attendant uniform)',
    subcategoryId: 'clothing',
  },
  {
    id: 'high_heels',
    label: 'High Heels',
    prompt: 'High heels',
    subcategoryId: 'clothing',
  },
  {
    id: 'secretary',
    label: 'Secretary',
    prompt: 'Secretary outfit, tight skirt',
    subcategoryId: 'clothing',
  },
  {
    id: 'suit',
    label: 'Suit',
    prompt: 'suit and shirt',
    subcategoryId: 'clothing',
  },
  {
    id: 'teacher',
    label: 'Teacher',
    prompt: 'Teacher outfit, skirt, shirt',
    subcategoryId: 'clothing',
  },
  {
    id: 'thigh_socks',
    label: 'Thigh Socks',
    prompt: 'Thigh-high socks',
    subcategoryId: 'clothing',
  },
  {
    id: 'waitress',
    label: 'Waitress',
    prompt: '(Waitress) uniform',
    subcategoryId: 'clothing',
  },
  {
    id: 'yoga_pants',
    label: 'Yoga Pants',
    prompt: 'Yoga pants',
    subcategoryId: 'clothing',
  },
  {
    id: 'tank_top',
    label: 'Tank Top',
    prompt: 'Tank top',
    subcategoryId: 'clothing',
  },
  {
    id: 'mini_skirt',
    label: 'Mini Skirt',
    prompt: 'Mini skirt',
    subcategoryId: 'clothing',
  },
  {
    id: 'maid',
    label: 'Maid',
    prompt: '(Maid) outfit',
    subcategoryId: 'clothing',
  },
  {
    id: 'shirt',
    label: 'Shirt',
    prompt: 'Shirt',
    subcategoryId: 'clothing',
  },
  {
    id: 'jeans',
    label: 'Jeans',
    prompt: 'Jeans',
    subcategoryId: 'clothing',
  },
];

export const PLACE_OPTIONS = [
  {
    id: 'beach',
    label: 'Beach',
    prompt: 'Beach',
    subcategoryId: 'scene',
  },
  {
    id: 'bedroom',
    label: 'Bedroom',
    prompt: 'Bedroom',
    subcategoryId: 'scene',
  },
  {
    id: 'forest',
    label: 'Forest',
    prompt: 'Forest',
    subcategoryId: 'scene',
  },
  {
    id: 'gym',
    label: 'Gym',
    prompt: 'Gym',
    subcategoryId: 'scene',
  },
  {
    id: 'night club',
    label: 'Night club',
    prompt: 'Night club',
    subcategoryId: 'scene',
  },
  {
    id: 'kitchen',
    label: 'Kitchen',
    prompt: 'Kitchen',
    subcategoryId: 'scene',
  },
  {
    id: 'living-room',
    label: 'Living room',
    prompt: 'Living room',
    subcategoryId: 'scene',
  },
  {
    id: 'office',
    label: 'Office',
    prompt: 'Office',
    subcategoryId: 'scene',
  },
  {
    id: 'pool',
    label: 'Pool',
    prompt: 'Pool',
    subcategoryId: 'scene',
  },
  {
    id: 'school',
    label: 'School',
    prompt: 'School',
    subcategoryId: 'scene',
  },
  {
    id: 'street',
    label: 'Street',
    prompt: 'Street',
    subcategoryId: 'scene',
  },
  {
    id: 'strip-club',
    label: 'Strip club',
    prompt: 'Strip club',
    subcategoryId: 'scene',
  },
  {
    id: 'subway',
    label: 'Subway',
    prompt: 'Subway',
    subcategoryId: 'scene',
  },
];

export const COMPOSITION_OPTIONS = [
  {
    id: 'portrait',
    label: 'Portrait',
    prompt: 'portrait of ',
    subcategoryId: 'view',
  },
  {
    id: 'full-body',
    label: 'Full body',
    prompt: '(Full-body professional shot:1.2)',
    negativePrompt: '(Close-up:1.1)',
    subcategoryId: 'view',
  },
  {
    id: 'back',
    label: 'Back view',
    prompt: '(Photo from behind:1.1)',
    subcategoryId: 'view',
  },
  {
    id: 'close-up',
    label: 'Close-up',
    prompt: 'Close-up',
    subcategoryId: 'view',
  },

  {
    // POV porn thing here? Maybe need to change "base" first?
    id: 'first-person',
    label: 'First person',
    prompt: 'First person view',
    subcategoryId: 'view',
  },
  {
    id: 'fisheye',
    label: 'Fisheye',
    prompt: '(Fisheye shot:1.1)',
    subcategoryId: 'view',
  },
  {
    id: 'wide-angle',
    label: 'Wide angle',
    prompt: 'Wide angle view',
    subcategoryId: 'view',
  },
];

export const ACTION_OPTIONS: AttributeOption[] = [
  {
    id: 'standing',
    label: 'Standing',
    prompt: 'Standing',
    subcategoryId: 'action',
  },
  {
    id: 'sitting',
    label: 'Sitting',
    prompt: '(Sitting)',
    subcategoryId: 'action',
  },
  {
    id: 'lying',
    label: 'Lying',
    prompt: '(Lying down:1.1)',
    subcategoryId: 'action',
  },
  {
    id: 'dancing',
    label: 'Dancing',
    prompt: '(Dancing)',
    subcategoryId: 'action',
  },
  {
    id: 'posing',
    label: 'Posing',
    prompt: '(Posing)',
    subcategoryId: 'action',
  },
  {
    id: 'walking',
    label: 'Walking',
    prompt: '(Walking)',
    subcategoryId: 'action',
  },
  {
    id: 'running',
    label: 'Running',
    prompt: 'Running',
    subcategoryId: 'action',
  },
  {
    id: 'jumping',
    label: 'Jumping',
    prompt: 'Jumping',
    subcategoryId: 'action',
  },
  {
    id: 'squatting',
    label: 'Squatting',
    prompt: 'Squatting',
    subcategoryId: 'action',
  },
  {
    id: 'bending-over',
    label: 'Bending over',
    prompt: 'Bending over',
    subcategoryId: 'action',
  },
];

export const PERSONA_OPTIONS: AttributeOption[] = [
  {
    id: 'girlfriend',
    label: 'Girlfriend',
    prompt:
      "Assistant acts as user's girlfriend: cute, loving, caring, sexy, flirty",
    subcategoryId: 'persona',
  },
  {
    id: 'horny',
    label: 'Horny',
    prompt:
      'Assistant is very horny and explicit: always ready to fuck or sext. Very flirty',
    subcategoryId: 'persona',
  },
  {
    id: 'jerk-off-instructions',
    label: 'Jerk-off instructions',
    prompt: `Assistant provides jerk-off instructions to the users. Build anticipation gradually with varied intensity levels. Provide gradual, multi-phase instructions using vivid sensory details. Assistant is sexy and should be horny`,
    subcategoryId: 'persona',
  },
  {
    id: 'dominatrix',
    label: 'Dominatrix',
    prompt:
      'Assistant assumes a dominant FEMALE role: gives commands, uses humiliation play, controls the scene. Talks authoritatively',
    subcategoryId: 'persona',
  },
  {
    id: 'cheating-fantasy',
    label: 'Cheating Fantasy',
    prompt:
      "Assistant pretends to be someone else's partner engaging in secret affair. Includes guilty pleasure elements",
    subcategoryId: 'persona',
  },
  {
    id: 'public-risky',
    label: 'Public Risky',
    prompt:
      'Simulates encounters in public spaces where risk of discovery creates excitement. Focuses on stealthy tension',
    subcategoryId: 'persona',
  },
  {
    id: 'colleague',
    label: 'Colleague',
    prompt:
      'Assistant is a colleague: professional, friendly, helpful, but not too close',
    subcategoryId: 'persona',
  },
  {
    id: 'celebrity',
    label: 'Celebrity',
    prompt:
      'Assistant is a celebrity: famous, glamorous, charismatic, but not too close',
    subcategoryId: 'persona',
  },
];

// Add NAME_OPTIONS constant
export const NAME_OPTIONS: AttributeOption[] = [
  { id: 'alice', label: 'Alice', prompt: 'Alice', subcategoryId: 'name' },
  { id: 'bob', label: 'Bob', prompt: 'Bob', subcategoryId: 'name' },
  { id: 'charlie', label: 'Charlie', prompt: 'Charlie', subcategoryId: 'name' },
  { id: 'diana', label: 'Diana', prompt: 'Diana', subcategoryId: 'name' },
  { id: 'emma', label: 'Emma', prompt: 'Emma', subcategoryId: 'name' },
  { id: 'frank', label: 'Frank', prompt: 'Frank', subcategoryId: 'name' },
  { id: 'grace', label: 'Grace', prompt: 'Grace', subcategoryId: 'name' },
  { id: 'henry', label: 'Henry', prompt: 'Henry', subcategoryId: 'name' },
  {
    id: 'isabelle',
    label: 'Isabelle',
    prompt: 'Isabelle',
    subcategoryId: 'name',
  },
  { id: 'james', label: 'James', prompt: 'James', subcategoryId: 'name' },
];

// Group related attributes for UI organization
export const ATTRIBUTE_GROUPS = [
  {
    id: 'basic',
    label: 'Basic Information',
    attributes: ['gender', 'age', 'origin'],
  },
  {
    id: 'appearance',
    label: 'Appearance',
    attributes: [
      'faceType',
      'hairColor',
      'hairStyle',
      'eyeColor',
      'bodyType',
      'boobs',
      'clothing',
    ],
  },
  {
    id: 'context',
    label: 'Context',
    attributes: ['place', 'composition', 'action'],
  },
  {
    id: 'personality',
    label: 'Persona',
    attributes: ['persona', 'name'],
  },
];

// Map attribute keys to their option arrays for easy lookup
export const ATTRIBUTE_OPTIONS_MAP = {
  gender: GENDER_OPTIONS,
  age: AGE_OPTIONS,
  origin: ORIGIN_OPTIONS,
  faceType: FACE_TYPE_OPTIONS,
  hairColor: HAIR_COLOR_OPTIONS,
  hairStyle: HAIR_STYLE_OPTIONS,
  eyeColor: EYE_COLOR_OPTIONS,
  bodyType: BODY_TYPE_OPTIONS,
  boobs: BOOB_OPTIONS,
  clothing: CLOTHING_OPTIONS,
  place: PLACE_OPTIONS,
  composition: COMPOSITION_OPTIONS,
  action: ACTION_OPTIONS,
  persona: PERSONA_OPTIONS,
  name: NAME_OPTIONS,
};
